import { Table, Tooltip, Card } from "antd";
import { withRouter } from "react-router-dom";
import AppLayout from "../../components/layouts/AppLayout/index";
import Loading from "../../components/loading";
import { useEffect, useRef, useState } from "react";
import PlateService from "../../app/service/plateService";
import moment from "moment";
import { Button as ButtonAntd, Modal } from "antd";
import {  CloseOutlined } from "@ant-design/icons";
import CmdService from "../../app/service/cmdService";
import { messageError, messageSuccess } from "../../components/toastr";
import styles from './routeInitiated.module.scss';

const TIME_FETCH_DATA = 60000;

export const RouteInitiated = () => {


    const routePlateService = new PlateService();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const plateSelected = useRef("");
    const cmdService = new CmdService();



    const getStatusLinkRoutePlate = () => {
        routePlateService
            .getLinkLoadRoute()
            .then((response) => {
                let list = [];
                response.data.data.forEach((element, index) => {
                    if ((element.routeLoadStatus === "CONCLUDED") && (element.routeStartStatus === "STARTED" || element.routeStartStatus === "PROCESSING")) {

                        list.push({ "key": index, "element": element });
                    }
                });
                setData(list);
            })
            .catch((error) => {
                console.log("Error", error);
            });
    };

    const handleSendStopRoute = () => {
        const data = {
            plate: plateSelected.current,
        }
        cmdService.sendRoute(data, "stop").then((response) => {
            if (response.data.status === 200) {
                messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
                getStatusLinkRoutePlate();
            } else {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            }
        }).catch((error) => {
            console.error("Error", error);
        });
    }


    const handleRowClicked = (row) => {
        plateSelected.current = row.element.plate;
    };

    const handleConfirmStopRoute = () => {
        Modal.confirm({
            title: 'Finalizar Rota.',
            content: 'Deseja realmente finalizar a rota?',
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk() {
                handleSendStopRoute()
            },
        });
    }

    const columns = [
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Placa</div>
            },
            dataIndex: "plate",
            key: "plate",
            width: 90,
            align: 'center',
            filterSearch: true,
            render: (_, data) => {
                const plate = data.element.plate;
                return <Tooltip title="Placa"><div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{plate}</div></Tooltip>;
            },
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Rota</div>
            },
            dataIndex: "name",
            key: "name",
            width: 100,
            align: 'center',
            render: (_, data) => {
                const route = data.element.routeName;
                return <Tooltip title="Rota"><div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{route}</div></Tooltip>;
            },
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Ativada em</div>
            },
            dataIndex: "startDate",
            key: "startDate",
            width: 130,
            align: 'center',
            render: (status, data) => {
                const dateTime = moment(data.element.startDate).format("DD/MM/YYYY, HH:mm:ss");
                const isCommandProcessing = data.element.routeStartStatus;
                return (
                    <>
                        {
                            isCommandProcessing !== "PROCESSING" ?
                                <Tooltip title="Início do processo">
                                    <div style={{ color: 'black', fontSize: '12px', fontWeight: 500 }}>{dateTime}</div>
                                </Tooltip>
                                :
                                <Tooltip title="Processando comando">
                                    <div className={styles.textStyleWave}>PROCESSANDO</div>
                                </Tooltip>
                        }
                    </>
                );
            },
        },
        {
            title: () => {
                return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Ação</div>
            },
            dataIndex: "routeLoadStatus",
            key: "routeLoadStatus",
            width: 130,
            align: 'center',
            render: (status, data) => {
                const isCommandProcessing = data.element.routeStartStatus === "PROCESSING";
                return (
                    <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
                        <Tooltip
                            placement="top"
                            title={"Finalizar rota"}
                        >
                            <ButtonAntd
                                size="small"
                                onClick={handleConfirmStopRoute}
                                icon={<CloseOutlined />}
                                style={{
                                    backgroundColor: isCommandProcessing ? "#DCDBDB" : "#246192",
                                    display: "flex",
                                    alignContent: "center",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "4px",
                                    width: "150px",
                                    color: isCommandProcessing ? "GrayText" : "white",
                                    fontSize: '12px',

                                }}
                                disabled={isCommandProcessing}
                                children="Finalizar Rota"
                            />
                        </Tooltip>
                    </div>

                );
            },
        },
    ];

    useEffect(() => {
        if (loading) {
            getStatusLinkRoutePlate();
        }
        setInterval(() => {
            getStatusLinkRoutePlate();
        }, TIME_FETCH_DATA);
        setLoading(false);
    }, []);

    return (
        <>
            <AppLayout>
                {loading ? (
                    <Loading />
                ) : (
                    <Card title="Rotas Ativas" style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}>
                        <Table
                            style={{ height: '100%' }}
                            locale={{ emptyText: "Sem vínculos." }}
                            scroll={{ x: "max-content" }}
                            size="small"
                            loading={false}
                            dataSource={data}
                            columns={columns}
                            pagination={true}
                            rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                            onRow={(record) => {
                                return {
                                    onClick: () => {
                                        handleRowClicked(record);
                                    },
                                };
                            }}
                        />
                    </Card>
                )}
            </AppLayout>
        </>
    );

}

export default withRouter(RouteInitiated);